import type { MediaPickerNode } from '@/Components/inputs/MediaPicker';
import type { SelectOptionType } from '@/Types';
import {
  PostStatusEnum,
  type ZnglyVideoCategoriesInput,
  type ZnglyVideoMediaNameEnum,
  type ZnglyVideoPostTypeEnum,
  type ZnglyVideoTagsInput,
} from '@/graphql/types';

// original content form state
// we freeze the object to make it immutable.
const contentFormState = {
  title: '' as string,
  contentLink: '' as string,
  status: PostStatusEnum.Draft as PostStatusEnum,
  description: '' as string,
  categories: { nodes: [], append: false } as ZnglyVideoCategoriesInput,
  initCategories: { nodes: [], append: false } as ZnglyVideoCategoriesInput,
  tags: { nodes: [], append: false } as ZnglyVideoTagsInput,
  contentMediaNode: null as MediaPickerNode | null,
  contentEmbedHtml: null as string | null,
  featuredImageMediaNode: null as MediaPickerNode | null,
  featuredImageLink: null as string | null,
  formOption: null as SelectOptionType | null,
  contentMediaType: null as ZnglyVideoPostTypeEnum | null,
  contentMediaName: null as ZnglyVideoMediaNameEnum | null,
  htmlDesc: null as string | null,
  ctaName: null as string | null,
  ctaLink: null as string | null,
  aiSummary: null as string | null,
};

export const initContentFormState = Object.freeze(contentFormState);

export type ContentFormState = typeof contentFormState;
